import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

export const enableFileExifMtime: boolean = isFeature('enable-file-exif-mtime');

export const exifDatesPriority: string[] = getFeature('exif-dates-order') || ['DateTimeOriginal', 'DateTimeDigitized', 'DateTime'];

export const extsWithExif: string[] = getFeature('exts-with-exif') || ['jpg', 'jpeg', 'jpe', 'heic', 'tiff', 'tif', 'webp'];
